



































import { Component, Prop, Vue } from 'vue-property-decorator';
import DynamicForm from '@/components/Form/DynamicForm.vue';
import { CustomField, CustomFieldData } from '@/models/Contact';
import { Meeting } from '@/models/CalendarEntries';
import { websiteText } from '@/mixins/websiteTexts';

@Component({
    components: {
        DynamicForm
    }
})
export default class BookingForm extends Vue {
    @Prop() timeSlotValid!: boolean;
    
    acceptChecked: boolean = false;
    submitAttempted: boolean = false;

    formData: Meeting = {
        id: '',
        person: '',
        startDate: '',
        endDate: '',
        meetingType: '',
        bookedManually: false,
        customerName: '',
        customerEmail: '',
        customerPhone: '',
        customerAddress: '',
        customerMessage: '',
        zoomMeetingInfo: '',
        token: ''
    };

    get formFields(): CustomField[] {
        return [
            { fieldType: 'TextField', placeholder: websiteText('retailer.firstandlastname'), mandatory: true, autocomplete: 'name', tabIndex: 1 },
            { fieldType: 'EmailField', placeholder: websiteText('retailer.email'), mandatory: true, autocomplete: 'email', tabIndex: 2 },
            { fieldType: 'TextField', placeholder: websiteText('retailer.cellphone'), mandatory: false, autocomplete: 'tel', tabIndex: 3 },
            { fieldType: 'TextField', placeholder: websiteText('retailer.address'), mandatory: false, autocomplete: 'address-line1', tabIndex: 4 },
            { fieldType: 'TextField', placeholder: websiteText('retailer.zipcode'), mandatory: true, autocomplete: 'postal-code', tabIndex: 5 },
            { fieldType: 'TextField', placeholder: websiteText('retailer.city'), mandatory: true, autocomplete: 'address-level2', tabIndex: 6 },
            { fieldType: 'MultirowTextField', placeholder: websiteText('retailer.describeMeeting'), mandatory: true, tabIndex: 7 }
        ];
    }

    get formComplete(): boolean {
        return this.acceptChecked && this.timeSlotValid;
    }

    handleDynamicSubmit(dynamicData: CustomFieldData[]) {
        this.submitAttempted = true;
        
        if (this.formComplete) {
            this.formData.customerName = dynamicData[0].value;
            this.formData.customerEmail = dynamicData[1].value;
            this.formData.customerPhone = dynamicData[2].value;
            
            const tmpAddress = dynamicData[3].value;
            const tmpPostalCode = dynamicData[4].value;
            const tmpCity = dynamicData[5].value;
            this.formData.customerAddress = `${tmpAddress}, ${tmpPostalCode} ${tmpCity}`;
            
            this.formData.customerMessage = dynamicData[6].value;

            this.$emit('submitBooking', this.formData);
        }
    }
}
